import { useQuery } from "@tanstack/react-query";
import { ApiServiceErr, axiosApi } from "./apiService";

interface GetChangeReasonLogInput {
  from: string | null;
  to: string | null;
  sourceId: string;
  ownerId: string;
}

export const useGetChangeReasonLog = (data: GetChangeReasonLogInput) => {
  return useQuery<string[], ApiServiceErr>(
    ["getChangeReasonLog", data],
    async () => {
      const response = await axiosApi.post("/change-reason-log/find-by-date", data);
      return response?.data;
    },
    {
      enabled: !!data?.from && !!data?.to && !!data?.sourceId && !!data?.ownerId
    }
  );
};
